var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.941 15.049H1.725C.773 15.049 0 14.276 0 13.323V3.402c0-.953.773-1.726 1.725-1.726h11.216c.953 0 1.726.773 1.726 1.726v9.921c0 .953-.773 1.726-1.726 1.726zM.419 5.029L14.667 5.029M3.333 0L3.333 2.933M11.333 0L11.333 2.933",
    transform: "translate(-1332 -544) translate(960 474) translate(0 60) translate(372 10) translate(.667 .133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61 9.638L6.705 11.733 10.895 7.543",
    transform: "translate(-1332 -544) translate(960 474) translate(0 60) translate(372 10) translate(.667 .133)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar);
export default __webpack_public_path__ + "static/media/icoCalendar.1d7c7dcc.svg";
export { ForwardRef as ReactComponent };